<template>
  <div class="pb-3">
    <div class="row">
      <div class="col-md-3">
        <div class="child-row-item__title">Phone</div>
        <div class="child-row-item__subtitle">
          {{ shipment.recipient.phoneNumber }}
          <small class="text-muted">
            {{ shipment.recipient.phoneType }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="child-row-item__title">Email</div>
        <div class="child-row-item__subtitle">
          {{ shipment.recipient.email }}
          <div v-if="shipment.recipient.emailIsFake">
            <small class="text-danger"> Not real email, messages will not be sent here </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'ContactData',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    return {}
  },
})
</script>
